export const storageHistory = {
	label: "Transaction Report",
	description:
		"The Stock Movement Report allows a detailed analysis of all incoming and outgoing movements carried out in a given period.",
	filename: "transaction-report",
	print: "Print",
	export: "Download in Excel",
	cleanFilters: "Clear filters",
	emptyState: {
		title: "Select and apply filters to start",
		description:
			"You need to select at least one stock, one category or one product and the period to start",
	},
	storages: {
		label: "Stocks",
		placeholder: "Search for stock",
	},
	filterBy: {
		label: "Filter by",
		category: "Category",
		product: "Product",
	},
	products: {
		label: "Products",
		placeholder: "Search for product",
	},
	categorys: {
		label: "Categories",
		placeholder: "Search for category",
	},
	period: "Period",
	filter: "Apply filters",
	hideProducts: "Do not show items with datasheet",
	dateFilterBy: {
		label: "Filter period by",
		options: {
			events: "Events between interval",
			interval: "All between interval",
		},
	},
	columns: {
		name: "Product",
		sku: "SKU",
		ube: "Unit",
		inicial: "Initial Quantity",
		input: "Product entry",
		transfer: "Internal transfer",
		sell: "Sales",
		productionIn: "Production input",
		productionOut: "Production output",
		lost: "Losses",
		manual: "Manual Adjustment",
		cardExchange: "Returns",
		result: "Final",
		lossPercentage: "Loss percentage",
	},
	editModal: {
		title: "Edit stock alerts for {{productName}}",
		deleteWarning: "Are you sure you want to delete the alert for {{productName}}?",
		delete: "Delete alert",
		storageIn: "Stock in",
		alert: "Alert",
		critical: "Critical",
		storage: "Stock",
		below: "below",
		invalidText: "The alert stock value cannot be less than the critical stock value",
	},
	printable: {
		product: "Product",
		initialQuantity: "Initial Qtt",
		productEntry: "Prod Ent.",
		internalTransfer: "Internal Transfer",
		sales: "Sales",
		productionEntry: "Production Entry",
		productionOutput: "Production Output",
		losses: "Loss",
		manualAdjustment: "Manual Adjustment",
		final: "End",
		withoutProducts: "No products selected",
	},
	storageReport: "Inventory Report",
};
